/**
 * Symbolpfade und Startseiten-Katalog — WÖRTLICH aus dem HTML-Prototyp
 * (Konstante `IC`, Methode `katalogBauen`).
 *
 * Diese Datei wird nicht „verbessert". Sie ist die Vorlage.
 */

/** Die Symbole des Entwurfs als reine Pfaddaten (24×24, Kontur). */
/*
 * `as const` und der abgeleitete `Symbolschluessel` weiter unten sind kein
 * Schmuck. Vorher stand hier `Record<string, string>`, und ein Katalogeintrag
 * mit dem erfundenen Symbol `nutzer` uebersetzte anstandslos — `IC['nutzer']`
 * ist dann `undefined`, und die Kachel stuende ohne Zeichnung da. Genau die
 * Klasse, die am 13.08.2026 sechs von elf Objektarten farblos liess, weil ein
 * undefiniertes CSS-Token still durchging. Beim ersten Versuch am 14.08. ist
 * mir derselbe Fehler unterlaufen; jetzt faellt er beim Uebersetzen auf.
 */
export const IC = {
  home: 'M3 11l9-8 9 8v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z',
  grid: 'M3.6 18a9 9 0 1 1 16.8 0M12 12l4.6-3.6M12 12v.01M6.5 12h.01M12 6.4v.01M17.5 12h.01',
  matrix: 'M3 4h18v16H3zM3 9h18M9 9v11M15 9v11',
  liste: 'M9 6h12M9 12h12M9 18h12M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  stift: 'M4 20h4L20 8l-4-4L4 16zM14 6l4 4',
  graph: 'M12 4v5m0 6v5M5 8.5l4 2.5m6 0l4-2.5M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6M5 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M19 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M12 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4',
  heat: 'M3.5 3.5h17v17h-17zM3.5 9.2h17M3.5 14.8h17M9.2 3.5v17M14.8 3.5v17M9.6 9.6h4.8v4.8H9.6z',
  karten: 'M12 3l9 4.6-9 4.6-9-4.6zM3 12.4l9 4.6 9-4.6M3 17l9 4.6 9-4.6',
  apps: 'M3 5h18v14H3zM3 9.5h18M6 7.2h.01M8.6 7.2h.01M11.2 7.2h.01',
  ordner: 'M3 7a1 1 0 0 1 1-1h5l2 2h8a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  cloud: 'M7 18a4 4 0 0 1 0-8 5 5 0 0 1 9.6-1A3.5 3.5 0 0 1 18 18z',
  laptop: 'M3 6h11v8H3zM1.5 17h14M17 8.5h5.5v11H17z',
  zahnrad: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1',
  euro: 'M2.5 6.5h19v11h-19zM12 9.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8M5.5 10.5v3M18.5 10.5v3',
  gebaeude: 'M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16M15 10h4a1 1 0 0 1 1 1v10M4 21h17M7 8h4M7 12h4M7 16h4',
  personen: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M2 21c0-3.5 3-6 7-6s7 2.5 7 6M17 5a3 3 0 0 1 0 6M18 21c0-2.4-.7-4-2-5',
  tausch: 'M4 8h13l-3-3M20 16H7l3 3',
  plus: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 8v8M8 12h8',
  uhr: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7v5l3.5 2',
  haken: 'M9 3.5h6v3H9zM6 6.5h12v15H6zM9.4 14l2.2 2.2L15.4 12',
  pfeil: 'M4.5 12a7.5 7.5 0 0 1 12.4-5.6M19.5 12a7.5 7.5 0 0 1-12.4 5.6M17.4 3.2v3.6h-3.6M6.6 20.8v-3.6h3.6',
  kreis: 'M20 12a8 8 0 1 1-2.6-5.9M20.5 4v4h-4M8.6 12l2.4 2.4L15.8 9.6',
  warnung: 'M12 3l9.5 17H2.5L12 3zM12 9v5M12 17.2v.1',
  regel: 'M6 3h9l4 4v14H6zM15 3v4h4M9 12h6M9 16h4',
  box: 'M3.5 5.5h4.5v4.5H3.5zM3.5 14h4.5v4.5H3.5zM11 7.8h9.5M11 16.2h9.5',
  schild: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  upload: 'M12 2.8l3 2.4h4v4l2 2.8-2 2.8v4h-4l-3 2.4-3-2.4H5v-4L3 15l2-2.8v-4h4zM9.6 12l1.9 1.9 3.5-3.6',
  export: 'M6 3h9l4 4v14H6zM15 3v4h4M12 11v6M9.6 14.6L12 17l2.4-2.4',
  verlauf: 'M3 12a9 9 0 1 0 3-6.7M3 4v4h4M12 8v4l3 2',
  blitz: 'M2.5 12h4l2.2-5.5 3.2 11 2.2-5.5h7.4',
  sitemap: 'M9 4h6v4H9zM3 16h6v4H3zM15 16h6v4h-6zM12 8v4M12 12H6v4M12 12h6v4',
  tastatur: 'M12 7.5a4 4 0 0 1 4 4v2.5a4 4 0 0 1-8 0V11.5a4 4 0 0 1 4-4M9.5 5.2l1.4 2.1M14.5 5.2l-1.4 2.1M4 12h4M16 12h4M5 17.5l3-1.6M19 17.5l-3-1.6',
  sonne: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8M12 2v2M12 20v2M4 12H2M22 12h-2M5.6 5.6L4.2 4.2M19.8 19.8l-1.4-1.4M5.6 18.4l-1.4 1.4M19.8 4.2l-1.4 1.4',
  mond: 'M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z',
} as const;

/** Die Symbolnamen, die es wirklich gibt. */
export type Symbolschluessel = keyof typeof IC;

/**
 * Ein Symbol nachschlagen, wenn der Name erst zur Laufzeit feststeht.
 *
 * Navigationseintraege und Graphknoten tragen ihn als Zeichenkette; dort
 * greift die Typpruefung nicht, und ein Tippfehler ergaebe `undefined` —
 * `<path d={undefined}>` zeichnet nichts und meldet nichts.
 *
 * `Object.hasOwn` und nicht `in`: `IC['constructor']` liefert sonst die
 * Funktion aus dem Prototyp. Dieselbe Form hat am 13.08.2026 den
 * Entwicklungsserver beendet.
 */
export function symbol(name: string): string {
  return Object.hasOwn(IC, name) ? IC[name as Symbolschluessel] : IC.box;
}

/**
 * Woher die offene Menge einer Aufgabenkachel kommt.
 *
 * An dieser Stelle stand bis zum 13.08.2026 die Menge selbst — `12`, `2`, `7`,
 * aus der HTML-Vorlage übernommen und an nichts gebunden. Die Sieben an den
 * SoD-Konflikten war nachweislich falsch: seit `/sod` aus dem Bestand rechnet,
 * sind es im Entwicklungsbestand 63. Eine Zahl an prominenter Stelle, die
 * niemand nachrechnet, wird geglaubt; deshalb steht hier jetzt nur noch, **wo**
 * sie herkommt. Auflösung in `api/aufgabenzaehler.ts`.
 *
 * Ein Schlüssel ohne Quelle fällt beim Übersetzen auf — der Zähler bildet
 * diesen Typ vollständig ab.
 */
export type Zaehlerschluessel = 'freigaben' | 'rezert' | 'sod' | 'kontenWarten';

/**
 * Ein Katalogeintrag der Vorlage:
 * [Titel, Beschreibung, Symbol, Farbmerkmal, Ziel, benötigtes Recht, Zählerquelle]
 *
 * `zaehler` entscheidet zugleich über die Zweitverwendung: ein Eintrag mit
 * Quelle kann als priorisierte Aufgabe oben stehen, einer ohne bleibt ein
 * reiner Startpunkt.
 */
export type Kachel = [
  titelText: string,
  beschreibung: string,
  icon: Symbolschluessel,
  farbe: string,
  ziel: string,
  recht: string | null,
  zaehler: Zaehlerschluessel | null,
];

export const KATALOG: Array<[gruppe: string, kacheln: Kachel[]]> = [
  ['Personen', [
    ['Eintritt', 'Onboarding mit Standardrolle, Hardware und Postfachzugriffen in einem Vorgang.', 'personen', '--art-person', '/lifecycle?prozess=joiner', 'lifecycle.starten', null],
    ['Versetzung', 'Rollenwechsel bei Bereichs- oder Stellenwechsel, inklusive Entzug alter Rechte.', 'tausch', '--art-person', '/lifecycle?prozess=mover', 'lifecycle.starten', null],
    ['Austritt', 'Austritt vorbereiten: Rechte entziehen, Postfach übergeben, Hardware zurückfordern.', 'pfeil', '--art-person', '/lifecycle?prozess=leaver', 'lifecycle.starten', null],
    ['Vertretung', 'Befristete Zusatzberechtigung für Urlaub oder Krankheit.', 'uhr', '--art-person', '/vertretungen', 'personen.lesen', null],
  ]],
  ['Zugriff', [
    ['Beantragen', 'Zusätzliche Applikation, Laufwerk, Postfach oder Verteiler für sich oder andere.', 'plus', '--art-app', '/antraege/neu', null, null],
    ['Entziehen', 'Nicht mehr benötigte Berechtigungen gezielt zurücknehmen.', 'regel', '--art-app', '/antraege/neu?typ=entzug', null, null],
    /* „Meine Zugriffe" stand hier bis zum 27.08.2026 und fuehrte auf
       `/personen/P-008` — eine feste **fremde** Personenkennung, fuer jeden
       Nutzer dieselbe. Wiederkommen kann der Eintrag, sobald `/api/ich` eine
       Personenkennung fuehrt; heute fuehrt es keine. */
  ]],
  /* **Anlegen verlangt das Anlegerecht, nicht das Leserecht.**

     Drei dieser Kacheln fuehren auf ein Anlegeformular (`?neu=1`) und
     verlangten `assets.lesen`; „Rolle anlegen" verlangte `rollen.schreiben`,
     obwohl `008` `rollen.anlegen` getrennt fuehrt. Wer nur lesen darf, sah
     die Kachel offen, bekam das Formular — und beim Speichern eine 403 der
     Schnittstelle. Ein Weg, der erst am Ende abweist, ist schlimmer als ein
     Schloss davor: die Eingaben sind dann schon gemacht.

     Aufgefallen ist es am 27.08.2026, als die Sperren von der im Browser
     gewaehlten Persona auf die echten Rechte umgestellt wurden. Vorher stand
     die Persona meist auf „IAM Admin" mit allen Rechten, und dort faellt
     kein Unterschied auf.

     `werkzeuge/test/kachelrechte.test.mjs` haelt es jetzt zusammen: jede
     Kachel mit `?neu=1` muss das `anlegerecht` ihrer Sammlung nennen. */
  ['Pflegen', [
    ['Rolle anlegen', 'Neue Standardrolle mit Berechtigungen und technischer Gruppenzuordnung.', 'stift', '--art-rolle', '/rollen/bearbeiten?neu=1', 'rollen.anlegen', null],
    ['Rolle bearbeiten', 'Berechtigungen einer bestehenden Rolle ändern.', 'matrix', '--art-rolle', '/rollen', 'rollen.schreiben', null],
    ['Applikation erfassen', 'Neue Anwendung inklusive Owner, Lizenzmodell und Berechtigungskonzept.', 'apps', '--art-app', '/assets/applikationen?neu=1', 'assets.anlegen', null],
    ['Technische Gruppe anlegen', 'Entra- oder AD-Gruppe nach Namenskonvention registrieren.', 'zahnrad', '--art-gruppe', '/assets/gruppen?neu=1', 'gruppen.anlegen', null],
    ['Laufwerk erfassen', 'Netzlaufwerk oder Ordner mit Lese- und Schreibrechten aufnehmen.', 'ordner', '--art-app', '/assets/fileserver?neu=1', 'assets.anlegen', null],
    /* Wer sich zum ersten Mal anmeldet, bekommt ein Konto ohne jedes Recht
       (`023`) und sieht überall „Keine Berechtigung". Bis zum 14.08.2026
       erfuhr davon niemand: die Warteliste stand unter `/konten` hinter einem
       Schalter, den man von sich aus finden musste. Ein Zugang, der still
       darauf wartet, dass jemand zufällig nachsieht, ist keiner. */
    ['Zugang freischalten', 'Wer sich zum ersten Mal angemeldet hat, wartet ohne Rechte auf eine Anwendungsrolle.', 'personen', '--art-person', '/konten?warten=ja', 'rechte.verwalten', 'kontenWarten'],
  ]],
  ['Prüfen & Auswerten', [
    ['Änderungsfreigaben bearbeiten', 'Vier-Augen-Prinzip: Änderungen an Rollen, Assets und Gruppen freigeben.', 'haken', '--art-rolle', '/genehmigungen', 'genehmigung.entscheiden', 'freigaben'],
    ['Abfragen & Anomalien', 'Auffälligkeiten im Bestand aufdecken.', 'regel', '--art-rolle', '/abfragen', 'governance.lesen', null],
    ['Klärungspunkte', 'Offene Fragen aus der Rollenmatrix abarbeiten.', 'box', '--art-oe', '/offene-punkte', 'governance.lesen', null],
    ['Rezertifizierung durchführen', 'Laufende Kampagne: Bestand bestätigen oder entziehen.', 'kreis', '--art-oe', '/rezertifizierung', 'governance.verwalten', 'rezert'],
    ['SoD-Konflikte prüfen', 'Unvereinbare Rechtekombinationen.', 'warnung', '--art-mail', '/sod', 'governance.verwalten', 'sod'],
    ['Bericht erstellen', 'Rollenmatrix, Lizenzkosten oder Prüfnachweis zusammenstellen.', 'export', '--art-hw', '/reports', 'reports.lesen', null],
  ]],
];

/* ------------------------------------------------------------ Stile ------
   Wörtlich aus `bauen()` und dem Aufgabenzweig von `katalogBauen()`. */

export const stilKachel = (gesperrt: boolean): string =>
  'display:flex;align-items:center;gap:11px;width:100%;padding:9px 10px;text-align:left;background:none;' +
  'border:1px solid transparent;border-radius:var(--r-md);cursor:' + (gesperrt ? 'not-allowed' : 'pointer') + ';' +
  'transition:background-color .12s,border-color .12s;' + (gesperrt ? 'opacity:.5;' : '');

export const stilKachelIcon = (farbe: string): string => 'flex:0 0 18px;color:var(' + farbe + ')';

/* Ohne Farbe: seit dem Wegfall des Streifens traegt die Karte keine mehr.
   Ein Parameter, den niemand liest, ist eine Zusage, die niemand einloest. */
export const stilAufgabe = (gesperrt: boolean): string =>
  'display:flex;align-items:center;gap:14px;width:100%;padding:14px 16px;text-align:left;' +
  'background:var(--surface-card);border:1px solid var(--border-subtle);' +
  /* Kein farbiger Streifen mehr an der linken Kante. Er stand als
     `box-shadow:inset 3px 0 0` vor der Zahl und war reine Dekoration: die
     Objektart traegt die Zahl bereits in ihrer Farbe. Der Kunde hat ihn am
     01.09.2026 gemeldet — er wirkte wie Schablone. Zwei Farbtraeger fuer
     dieselbe Angabe sind einer zu viel. */
  'border-radius:var(--r-lg);cursor:' + (gesperrt ? 'not-allowed' : 'pointer') + ';transition:border-color .15s' +
  (gesperrt ? ';opacity:.55' : '');

export const stilAufgabeZahl = (farbe: string): string =>
  'flex:0 0 auto;font-size:28px;line-height:32px;font-weight:600;letter-spacing:-.02em;color:var(' + farbe + ')';

export const stilKatalogAnpassen = (bearbeiten: boolean): string =>
  'height:28px;padding:0 10px;border-radius:var(--r-md);font-size:12px;cursor:pointer;border:1px solid ' +
  (bearbeiten ? 'var(--brand-primary)' : 'var(--border-default)') + ';background:' +
  (bearbeiten ? 'var(--brand-primary)' : 'var(--surface-card)') + ';color:' +
  (bearbeiten ? 'var(--text-on-brand)' : 'var(--text-secondary)');

export const RASTER_AUFGABEN =
  'display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:14px';

/*
 * Die Gruppen liegen als eigene Karten nebeneinander.
 *
 * Vorher standen sie als freie Spalten im Raum, nur getrennt durch eine
 * Haarlinie unter dem Titel — sieben gleich aussehende Listen ohne Kante.
 * Ein eigener Traeger je Gruppe gibt dem Auge etwas zum Festhalten und
 * trennt die Bereiche, ohne sie einzurahmen.
 *
 * `align-items:start` verhindert, dass alle Karten auf die Hoehe der
 * laengsten wachsen und unten leere Flaechen tragen.
 */
export const RASTER_KATALOG =
  'display:grid;grid-template-columns:repeat(auto-fit,minmax(268px,1fr));' +
  'gap:16px;align-items:start';

export const stilGruppe =
  'min-width:0;padding:14px 12px 10px;background:var(--surface-card);' +
  'border:1px solid var(--border-subtle);border-radius:var(--r-lg);box-shadow:var(--e0)';

/*
 * Gruppentitel: Grad und Farbe des Primaertexts statt winziger Versalien in
 * Tertiaerfarbe. Der farbige Punkt davor greift die Art der Gruppe auf und
 * gibt der Karte einen Anker.
 */
export const stilGruppeTitel =
  'display:flex;align-items:center;gap:8px;margin:0 0 8px;padding:0 4px 8px;' +
  'border-bottom:1px solid var(--border-subtle);' +
  'font-size:var(--grad-l);line-height:var(--zeile-l);font-weight:600;' +
  'letter-spacing:var(--spur-normal);color:var(--text-primary)';

export const START_UNTEN = 'display:block;margin-top:40px';

/**
 * Rahmen der Startseite.
 *
 * `margin:0 auto` fehlte hier: eine Maximalbreite ohne Zentrierung klebt am
 * linken Rand, und auf einem breiten Bildschirm steht die ganze Seite in der
 * Ecke. Dazu Luft nach oben — die Begruessung ist der erste Blick und braucht
 * Abstand zur Kopfzeile, keinen Anschlag.
 */
export const stilRahmen = (mobil: boolean): string =>
  'position:relative;max-width:1180px;margin:0 auto;width:100%;' +
  (mobil ? 'padding:12px 0 40px' : 'padding:28px 26px 56px');

export const stilTrennerLinks = (mobil: boolean): string => mobil
  ? 'display:block;height:1px;background:var(--border-subtle);margin:0 0 4px'
  : 'position:absolute;left:0;top:0;bottom:0;width:3px;border-radius:2px;background:linear-gradient(to bottom,var(--brand-primary),transparent)';

export const stilTrennerRechts = (mobil: boolean): string => mobil
  ? 'display:none'
  : 'position:absolute;right:0;top:0;bottom:0;width:3px;border-radius:2px;background:linear-gradient(to bottom,var(--brand-primary),transparent)';

/* „Zuletzt bearbeitet" stand hier bis zum 19.08.2026 als feste Liste: sechs
   Objekte mit Zeiten wie „vor 4 Min" und „gestern", fuer jeden Nutzer
   dieselben. Sie war die letzte erfundene Datenmenge der Oberflaeche und seit
   dem 13.08.2026 als offener Punkt vermerkt — mit der Begruendung, es gebe
   keine Quelle, solange kein Verlauf je Konto gefuehrt wird.

   Den Verlauf gibt es: `iam.Aenderung` traegt je Zeile den Akteur. Die
   Startseite liest ihn jetzt selbst (`seiten/Startseite.tsx`), gefiltert auf
   das eigene Konto und ueber `vorgangId` zusammengefasst. Die Liste hier
   ersatzlos zu streichen ist deshalb kein Verlust, sondern der Punkt. */

export const stilPunkt = (farbe: string): string =>
  'width:8px;height:8px;border-radius:999px;background:var(' + farbe + ')';

/** Begrüßung nach Tageszeit, wie in der Vorlage. */
export function begruessung(vorname: string, stunde = new Date().getHours()): string {
  const gruss = stunde < 11 ? 'Guten Morgen, ' : stunde < 18 ? 'Guten Tag, ' : 'Guten Abend, ';
  return gruss + vorname + '.';
}

/**
 * Lagebild-Satz — hängt am Modulzuschnitt des Mandanten.
 *
 * Er nannte bis zum 13.08.2026 Mengen und Termine: „3 eigene Anträge laufen
 * noch", „12 Änderungsfreigaben warten auf Ihre Entscheidung", dazu ein
 * Enddatum und eine Uhrzeit. Keine davon hing an einer Quelle — dieselbe
 * Klasse wie die 7 an den SoD-Konflikten, nur in einem Fließtext, wo sie noch
 * schwerer nachzurechnen ist. Für eigene Anträge gibt es bis heute keinen
 * Endpunkt; was offen ist, steht unmittelbar darunter unter „Liegt bei Ihnen"
 * und wird dort gerechnet. Der Satz sagt deshalb nur noch, was ihn trägt.
 */
export function startLage(antraegeAn: boolean): string {
  /* „Standardrollenmatrix" ist die Herkunft der Daten, nicht der Name des
     Werkzeugs — dieselbe Verwechslung, die bis zum 01.09.2026 auch im
     Browserreiter und auf der Anmeldekarte stand. */
  return antraegeAn
    ? 'Ihr Einstieg ins IAM: offene Vorgänge, Anträge und der Katalog aller Startpunkte.'
    : 'Ihr Einstieg ins IAM: offene Vorgänge und der Katalog aller Startpunkte.';
}

